module.exports = __webpack_public_path__ + "static/media/studio1-hover.9c1c365c.png";